import { ReactNode, useState, useCallback } from 'react';

import { BusinessPlanProgressContext } from './BusinessPlanProgressContext';

export function BusinessPlanProgressProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [completedSteps, setCompletedSteps] = useState<string[]>([]);
  const [currentStep, setCurrentStep] = useState<string>('executive-summary');
  const [totalStepsCount, setTotalStepsCount] = useState<number | undefined>(undefined);

  // Map to store completed steps per plan ID
  const [planCompletedSteps, setPlanCompletedSteps] = useState<Record<string, string[]>>({});

  const getCompletedStepsForPlan = useCallback((planId: string): string[] => {
    return planCompletedSteps[planId] || [];
  }, [planCompletedSteps]);

  const setCompletedStepsForPlan = useCallback((planId: string, steps: string[]) => {
    setPlanCompletedSteps(prev => ({
      ...prev,
      [planId]: steps
    }));

    // Also update the legacy completedSteps for backward compatibility
    setCompletedSteps(steps);
  }, []);

  const clearPlanProgress = useCallback((planId: string) => {
    setPlanCompletedSteps(prev => {
      const newState = { ...prev };
      delete newState[planId];
      return newState;
    });

    // Clear legacy state if it was for this plan
    setCompletedSteps([]);
    setCurrentStep('executive-summary');
  }, []);

  return (
    <BusinessPlanProgressContext.Provider
      value={{
        completedSteps,
        setCompletedSteps,
        currentStep,
        setCurrentStep,
        getCompletedStepsForPlan,
        setCompletedStepsForPlan,
        clearPlanProgress,
        totalStepsCount,
        setTotalStepsCount,
      }}
    >
      {children}
    </BusinessPlanProgressContext.Provider>
  );
}
